import { computed, makeAutoObservable } from 'mobx';
import { Common } from 'src/AppState/Common';
import { ToasterState } from 'src/AppState/ToasterState';

import { TrpcClient } from 'src/AppState/TrpcClient';

import { Resource } from 'src_common/common/mobx-utils/Resource';

import { ResponseType, SuccessResponseType } from 'src_server/types/paymentSearch/bonusList';

export class PaymentSearchFormState {
    public bonusList: Resource<ResponseType>;

    public constructor(
        private readonly common: Common,
        private readonly trpcClient: TrpcClient
    ) {
        this.bonusList = new Resource(async (): Promise<ResponseType> => {
            return await this.trpcClient.client.paymentSearchRouter.getBonusList.query();
        });

        makeAutoObservable(this);
    }

    @computed public get bonusListResponse(): SuccessResponseType | null {
        const response = this.bonusList.get();
        if (response.type === 'ready' && response.value.responseStatus === 'success') {
            return response.value.response;
        } else if (response.type === 'ready' && response.value.responseStatus === 'error') {
            ToasterState.get(this.common).setToast({
                variant: 'error',
                title: 'Error',
                message: response.value.data.message ?? 'Error fetching bonuses',
            });
        }
        return null;
    }

    @computed public get isLoading(): boolean {
        return this.bonusList.get().type === 'loading';
    }
}
